import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const DriveFileMoveRtlIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"drive_file_move_rtl"} ref={ref}/>
});

DriveFileMoveRtlIcon.displayName = "DriveFileMoveRtlIcon";
